import { render } from "./editAccount.vue?vue&type=template&id=71f242f9"
import script from "./editAccount.vue?vue&type=script&lang=js"
export * from "./editAccount.vue?vue&type=script&lang=js"

import "./editAccount.vue?vue&type=style&index=0&id=71f242f9&lang=less"
script.render = render

export default script